import React from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DashboardUserRequestResponse } from "../../../../../business";
import EngagementTable from "./dashboard-engagement-table.component.tsx";
import InfoCard from "./dashboard-infocard.component.tsx";

export const DashboardUserContent: React.FC<DashboardUserRequestResponse> = ({ response }) => {
    const { t } = useTranslation('admDashboard');
    return (
        <>
            <h4 className="mb-4">{t('pageTitle')}</h4>
            <Row>
                <InfoCard
                    bgColor="primary"
                    title={t('memberSince')}
                    value={response.subscriptons.created}
                    subtitle={t('noAlerts')}
                />
                <InfoCard
                    bgColor="secondary"
                    title={t('dailyFollowing')}
                    value={response.publishedCarParts}
                    subtitle={t('dailyFollowingDetails', { national: response.nationalCarParts, imported: response.importedCarParts })}
                />
                <InfoCard
                    bgColor="success"
                    title={t('subscription')}
                    value={`${response.subscriptons.plan}<span style="font-size: 10px"}> / ${response.subscriptons.frequency}</span>`}
                    subtitle={t('expires', { date: response.subscriptons.expires })}
                />
                <InfoCard
                    bgColor="dark"
                    title={t('engagement')}
                    value={response.engagement.total}
                    subtitle={t('peopleEngagement')}
                    online={true}
                />
                {response.mostViewedCarParts.image &&
                    <Col sm={12} md={3} className="mb-3">
                        <Card
                            bg="dark"
                            key={'mostviewed'}
                            text={'white'}
                            border="none"
                        >
                            <Card.Img src={response.mostViewedCarParts.image} alt={response.mostViewedCarParts.description} />
                            <Card.ImgOverlay>
                                <Card.Title style={{ textShadow: '1px 1px #333333' }}>
                                    <small>Mais Visto</small>
                                </Card.Title>
                                <Card.Text>
                                    <Badge bg="dark">{response.mostViewedCarParts.description}</Badge>
                                </Card.Text>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                }
                {response.engagement.total > 0 &&
                    <EngagementTable engagements={response.engagement.data} mt={3} />
                }
            </Row >
        </>
    )
}